module.exports = __webpack_public_path__ + "img/damage-red.9d34ffa3.svg";